import { useEffect } from "react";

export default function Terms() {
  useEffect(() => {
    document.title = "Terms of Service — Sutranode";
  }, []);

  return (
    <section className="section legal-section">
      <div className="container legal-container">
        <div className="s-eyebrow">Terms</div>
        <h1 className="s-title">Terms of Service</h1>
        <p className="legal-updated">Last updated: 5 May 2026</p>
        <div className="legal-body" style={{ marginTop: 24 }}>
          <h2>1. Working with us</h2>
          <p>
            Every project we take on is shaped by a written brief that includes scope, timeline, price,
            and ownership. The brief is the source of truth — these terms are the broader frame around
            it.
          </p>

          <h2>2. Scope of work</h2>
          <p>
            What's in scope and what's out is defined per project. New requests outside the agreed
            scope are handled either as a separate brief or under a clear change-request, with their
            own price and timeline.
          </p>

          <h2>3. Payments</h2>
          <p>
            Most projects are billed in milestones — typically a kickoff payment, a midpoint payment,
            and a final payment on launch or handover. Retainers are billed monthly in advance.
            Invoices are due within 7 days unless otherwise agreed.
          </p>

          <h2>4. Ownership</h2>
          <p>
            Once a project is paid in full, you own everything we built for you — the code, the
            content, the accounts, the automations. We retain the right to discuss the work as part of
            our portfolio unless you ask us not to.
          </p>

          <h2>5. Confidentiality</h2>
          <p>
            We treat anything you share with us — strategy, finances, internal data — as confidential.
            We expect the same in return for our methods, internal tools, and proprietary processes.
          </p>

          <h2>6. Timelines & dependencies</h2>
          <p>
            We commit to clear, honest timelines. In return, we ask for timely feedback and access to
            necessary accounts. If a project is significantly delayed by reasons outside our control,
            timelines are adjusted accordingly.
          </p>

          <h2>7. Liability</h2>
          <p>
            We do our best work, document carefully, and stand behind what we ship. That said, our
            total liability for any project is limited to the amount paid for that project.
          </p>

          <h2>8. Termination</h2>
          <p>
            Either side can end an engagement with reasonable notice. If a project ends mid-way, work
            done up to that point is invoiced and you receive everything completed in clean, usable form.
          </p>

          <h2>9. Governing law</h2>
          <p>These terms are governed by the laws of India.</p>

          <h2>10. Contact</h2>
          <p>Questions? Email <strong>hello@sutranode.in</strong> or message us on WhatsApp at +91 9108181932.</p>
        </div>
      </div>
    </section>
  );
}
